import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
const FIRST_DELAY = 9000;
const VISIBLE_MS = 6000;
const GAP_MS = 13000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const showTimer = window.setTimeout(() => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % purchaseNotifications.length);
      }, VISIBLE_MS);
    }, visible ? GAP_MS : index === 0 ? FIRST_DELAY : GAP_MS);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index, dismissed]);
  const person = purchaseNotifications[index];
  const minutes = index * 3 % 9 + 2;
  return <AnimatePresence data-id="element-43" data-mp="117628k2pbwoa">
      {visible && !dismissed ? <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-[104px] left-3 right-3 z-30 sm:right-auto sm:left-5 sm:bottom-[110px] sm:max-w-[340px]" role="status" aria-live="polite" data-id="element-44" data-mp="116mjj1589497">
          <div className="flex items-start gap-3 rounded-2xl border border-navy-deep/10 bg-white p-3 shadow-[0_12px_30px_rgba(8,24,42,0.16)]" data-id="element-45" data-mp="x518llc9701n">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-kidney-light" data-id="element-46" data-mp="s5exbhfzjtvh">
              <CheckCircle2Icon className="h-5 w-5 text-kidney-dark" aria-hidden="true" data-id="element-47" data-mp="28iwncsz8x6sc" />
            </div>
            <div className="min-w-0 flex-1" data-id="element-48" data-mp="23l3ji6lf0ov8">
              <p className="text-[13px] font-bold leading-snug text-navy-deep" data-id="element-49" data-mp="2ap2yj3htke80">
                {person.name} {person.flag}
              </p>
              <p className="mt-0.5 text-[12px] leading-snug text-navy/70" data-id="element-50" data-mp="2fm36xl255t2a">
                ha appena acquistato Percorso Malattia Renale™ dal{' '}
                {person.country}.
              </p>
              <p className="mt-1 text-[10.5px] font-semibold uppercase tracking-[0.1em] text-kidney-dark" data-id="element-51" data-mp="2plbxe3xsspjw">
                {minutes} minuti fa
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Chiudi notifica" className="shrink-0 rounded-lg p-1 text-navy/40 transition-colors duration-150 ease-out hover:bg-cream hover:text-navy" data-id="element-52" data-mp="1wy7xgddkb1ez">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-53" data-mp="198dlrz4zbiwb" />
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}